import PlaneAction from "./PlaneAction.js";
import {addHeading, getDistanceToTrack, getHeading, headingDiff} from "../../assets/virtual-flyout/nav-calc.js";
import {turn} from "../planeSlice.js";

export default class InterceptTrack extends PlaneAction {

    INTERCEPT_ANGLE = 45;

    constructor(planeId, waypoint1, waypoint2) {
        super(planeId);
        this.waypoint1 = waypoint1;
        this.waypoint2 = waypoint2;
        this.interceptAngle = this.INTERCEPT_ANGLE;
    }

    logAction() {
        this.log(`Intercepting track ${this.waypoint1.code} to ${this.waypoint2.code}`);
    }
    
    isOnInterceptHeading() {
        const planeState = this.getState();
        return planeState.heading === this.interceptHeading;
    }

    isOnTrack() {
        const planeState = this.getState();
        const currentCoordinates = planeState.coordinates;

        const distanceToTrack = getDistanceToTrack(currentCoordinates, this.waypoint1, this.waypoint2);
        const turnRadius = planeState.tas / 200;

        if ((distanceToTrack < turnRadius * this.interceptAngle / 90) ||
            (distanceToTrack > this.previousDistanceToTrack && distanceToTrack < 0.5)) {
            return true;
        } else {
            this.previousDistanceToTrack = distanceToTrack;
            return false;
        }

    }

    execute() {
        this.logAction();
        const trackToIntercept = getHeading(this.waypoint1, this.waypoint2);

        const planeState = this.getState();
        const currentCoordinates = planeState.coordinates;

        const directHeading = getHeading(currentCoordinates, this.waypoint2);
        const diffTrackVsDirect = headingDiff(trackToIntercept, directHeading);
        if (this.isOnTrack()) {
            let diffTrackVsHeading = headingDiff(planeState.heading, trackToIntercept);
            const interceptHeading = addHeading(trackToIntercept, this.interceptAngle * Math.sign(diffTrackVsHeading));
            this.interceptHeading = interceptHeading;
            this.dispatch(turn({heading: interceptHeading, roll: Math.sign(diffTrackVsHeading)}));
        } else {
            const interceptHeading = addHeading(trackToIntercept, this.interceptAngle * Math.sign(diffTrackVsDirect));
            this.interceptHeading = interceptHeading;
            this.dispatch(turn({heading: interceptHeading}));
        }

    }


    isComplete() {
        return this.isOnInterceptHeading() && this.isOnTrack();
    }
}